import React, { Fragment, useEffect, useState } from 'react'
import moment from 'moment'
import Empty from '../../components/Empty'
import Loader from '../../components/Loader'
import inspectionQueries from '../../queries/inspectionQueries'
import { Button, Progress } from '@nextui-org/react'
import { IconEye } from '@tabler/icons-react'
import { useNavigate } from 'react-router-dom'
import { RouteConstant } from '../../routes/RouteConstant'
import { useDispatch, useSelector } from 'react-redux'
import { setInspectionId } from '../../redux/reducers/inspectionReducers'
import PaginationComponent from '../../components/PaginationComponent'
import ReportModal from './ReportModal'

const InspectionScreen = () => {

    const [result, setResult] = useState([])
    const [loader, setLoader] = useState(true)

    const page = useSelector((state) => state.pagination.page)

    const dispatch = useDispatch()
    const navigation = useNavigate()

    const getData = inspectionQueries.useInspectionProgress(
        (res)=>{
            if(res?.success){
                setResult(res?.data)
            }
            setLoader(false)
        }
    )

    useEffect(() => {
      getData.mutateAsync({page, size: 10})
    }, [page]);

    const handleClick = (data) => {
        const { id } = data
        dispatch(setInspectionId(id))
        navigation(RouteConstant.SECTIONPROGRESS)
    }

  return (
    <div className='card-shadow m-4 max-[768px]:m-2 bg-white rounded-[10px]'>

        {
            loader ?
            <div className="w-full flex items-center justify-center py-40">
                <Loader />
            </div>:
            <div className='p-6 overflow-x-auto'>
                {
                    result?.totalItems > 0 ?
                        <table className='table w-full'>
                            <thead>
                                <tr className='table-row'>
                                    <th className='w-[60px]'>#</th>
                                    <th>Audit</th>
                                    <th>Inspection Date</th>
                                    <th>Vessel</th>
                                    <th>Auditor</th>
                                    <th className='w-[225px]'>Progress</th>
                                    <th className='flex justify-end' />
                                </tr>
                            </thead>
                            <tbody>
                                {result?.items?.map((row, index) => {
                                    const total = row?.total
                                    const done = row?.done
                                    const notDone = row?.notDone
                                    const notApplicable = row?.notApplicable
                                    const percentageCalc = ((done + notDone) / (total - notApplicable)) * 100
                                    const percentage = isNaN(percentageCalc) ? 0 : percentageCalc
                                    return(
                                        <tr key={index} className='table-row'>
                                            <td>{result?.currentPage * 10 + index + 1}</td>
                                            <td>{row?.audit?.name}</td>
                                            <td>{moment(row?.deadline).format('DD-MM-YYYY')}</td>
                                            <td>{row?.vessel?.name}</td>
                                            <td>{row?.user?.name}</td>
                                            <td>
                                                <div className='flex flex-col gap-2 justify-end'>
                                                    <div className='flex justify-between text-[12px]'>
                                                        {
                                                            percentage > 0 ?
                                                            <div>{percentage.toFixed(0)}% Completed</div>:
                                                            <div>Not Started</div>
                                                        }
                                                        <div>{row?.done + row?.notDone}/{row?.total - row?.notApplicable}</div>
                                                    </div>
                                                    <Progress value={percentage || 0} color="primary" />
                                                </div>
                                            </td>
                                            <td className='flex justify-end gap-2'>
                                                <Button onClick={()=>handleClick(row)} color="primary" isIconOnly size='sm'>
                                                    <IconEye size={16} />
                                                </Button>
                                                <ReportModal vesselName={row?.vessel?.name} audit={row?.audit_id} inspection={row?.id} />
                                            </td>
                                        </tr>
                                    )}
                                )}
                            </tbody>
                        </table>:
                    <Empty />
                }
                <PaginationComponent result={result} />
            </div>
        }
    </div>
  )
}

export default InspectionScreen